import React from 'react';
import icon_smile from "../../../assets/images/icon-user-lonchmara.svg";
import icon_close from "../../../assets/images/icon-close.svg";
import icon_star from "../../../assets/images/icon-star.svg";
import Icon from '../../atoms/Icon/Icon';
import useHomeLinkMode from '../../../hooks/useHomeLinkMode';
import './accountInfo.scss';
import useBrowserMode from '../../../hooks/useBrowserMode';
import useLocaleMode from '../../../hooks/useLocaleMode';
import { formatNumber } from '../../../state/utils/utilities-format-number';
import SessionService from '../../../services/session';

const AccountInfo = ({ handleCloseSession, isChangePassword, currentPoints, currentUser }) => {

    const { homeLink } = useHomeLinkMode();
    const { isBrowser } = useBrowserMode();
    const { locale } = useLocaleMode();
    let currentUserPoints =  currentPoints ? currentPoints : SessionService.getUserPoints();
    let currentUserName =  currentUser ? currentUser : SessionService.getUserName();
    return (
        <>
        {isBrowser &&
        <div className="f-userLogged-wrapper">
            <div className="f-userLogged-info">
                {currentUserName && currentUserName.length <= 8 ? <img src={icon_smile} alt="Icono sonrisa." className="f-icon-smile" /> : null}
                <p>
                    Hola,<br/>
                    <a href={`${homeLink}mi-cuenta/datos-personales`} >{currentUserName ? currentUserName : ""}</a>
                </p>
            </div>
            <div className="f-userLogged-points">
                {locale === "es-CO" ? <p className="f-points"><Icon tagtype="i" icon="icon-star" size="1" /> {formatNumber(currentUserPoints ? currentUserPoints : 0)} puntos</p> : null}
                <p className={!isChangePassword ? 'f-close' : 'f-close events'} onClick={handleCloseSession}><Icon tagtype="i" icon="icon-sesion-close" size="1" /> Cerrar sesión</p>
            </div>
            <div>
                
            </div>
        </div>
        }
        </>
    )
};

export default AccountInfo;